import { useLocation, useParams } from 'react-router-dom';
import { t } from '@/lib/i18n';
import { LibraryItemForm } from '../components/LibraryItemForm';
import { SystemReadOnlyView } from '../components/SystemReadOnlyView';
import { useLibraryItem } from '../hooks';
import type { LibraryItemDetail, LibraryKind } from '../schemas';

function kindFromPath(pathname: string): LibraryKind {
  return pathname.startsWith('/library/departments') ? 'unit' : 'position';
}

interface CustomizeBannerState {
  customizedFrom?: string;
  migratedMemberCount?: number;
}

export function LibraryItemFormPage() {
  const location = useLocation();
  const params = useParams<{ id?: string }>();
  const kind = kindFromPath(location.pathname);
  const id = params.id;
  const isEdit = Boolean(id && id !== 'new');

  const detail = useLibraryItem(kind, isEdit ? id : undefined);

  if (isEdit && detail.isLoading) {
    return <div role="status">{t('Loading…')}</div>;
  }
  if (isEdit && (!detail.data || detail.error)) {
    return <div role="alert">{t('This item is not available.')}</div>;
  }

  const item: LibraryItemDetail | undefined = isEdit ? detail.data?.item : undefined;

  if (item?.kind === 'system') {
    return <SystemReadOnlyView kind={kind} item={item} />;
  }

  const navState = (location.state ?? null) as CustomizeBannerState | null;

  return (
    <LibraryItemForm
      kind={kind}
      initial={item}
      banner={
        navState?.customizedFrom
          ? {
              customizedFrom: navState.customizedFrom,
              migratedMemberCount: navState.migratedMemberCount ?? 0,
            }
          : undefined
      }
    />
  );
}
